import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { AuthActions } from 'actions';

class Wakeup extends Component {

  componentDidMount() {
    const { router } = this.props;
    AuthActions.wakeUp(() => {
      router.replace('/dashboard');
    });
  }

  render() {
    return <div />;
  }
}

export default withRouter(Wakeup);



// WEBPACK FOOTER //
// ./src/js/components/Route/Wakeup.js